export enum TourKeys {
  NavigationTour = 'navigation-tour',
  GetToKnowTheInterface = 'get-to-know-the-interface-tour',
  LearnToShare = 'share-tour',
  SaveNodes = 'save-nodes-tour',
  ToolBuilder = 'tool-builder-tour',
  ToolToggleMoved = 'tool-toggle-moved-tour',
  PenToolIntro = 'pen-tool-intro',
  WelcomeTemplateGallery = 'welcome-template-gallery-tour',
  NUXEmptyCanvas = 'nux-empty-canvas-tour',
}

export const StepKeys = {
  NAVIGATION_TOUR: {
    WELCOME: 'welcome',
    PAN: 'pan',
    ZOOM: 'zoom',
    ADD_NODES: 'add-nodes',
    CONNECT_NODES: 'connect-nodes',
    RUN_MODEL: 'run-model',
    FINISH: 'finish',
  },
  GET_TO_KNOW_THE_INTERFACE: {
    WELCOME: 'welcome',
    CHANGE_RECIPE_NAME: 'change-recipe-name',
    SIDE_MENU: 'side-menu',
    FINISH: 'finish',
  },
  SAVE_NODES: {
    SAVE_CTA: 'save-cta',
    VIEW_SAVED_ITEMS: 'view-saved-item',
  },
  TOOL_BUILDER: {
    INTRO: 'intro',
    OUTPUT: 'output',
    INPUTS: 'inputs',
    DETAILS: 'details',
    PREVIEW: 'preview',
  },
  WELCOME_TEMPLATE_GALLERY: {
    WELCOME: 'welcome',
    TEMPLATE_GALLERY: 'template-gallery',
  },
  NUX_EMPTY_CANVAS: {
    WRITE_PROMPT: 'write-prompt',
    CONNECT_NODE: 'connect-node',
    ADD_MODEL: 'add-model',
    RUN_MODEL: 'run-model',
    MAKE_IT_YOUR_OWN: 'make-it-your-own',
  },
} as const;

export const ComponentKeys = {
  FLOW: 'flow',
};
